import { z } from 'zod';
/**
 * Ключи `app_settings` и форма их значения для ВСЕЙ автоматики реакций на
 * алерты платёжного риска.
 *
 * Живут здесь, в доменном пакете, а не в `admin-contracts` (как
 * `SUPPRESS_NON_CUSTOMER_KEY` в `llm-settings.ts`) по одной причине:
 * `@wit-support/risk-alerts` — единственный пакет, от которого УЖЕ зависят
 * все четыре стороны, читающие или пишущие эти флаги, — воркер
 * (`risk-reactor.ts`), `app-runtime` (`risk-reaction-sweeper.ts`),
 * `admin-contracts` и `admin-api`. Объявление в `admin-contracts` заставило
 * бы `app-runtime` зависеть от контрактов админки ради одной строки, а
 * дубликат строкового литерала в двух пакетах — это ровно тот дрейф, от
 * которого общий ключ и защищает (флаг, записанный админкой под одним
 * именем и прочитанный воркером под другим, выглядит как «тумблер не
 * работает»).
 *
 * Все четыре по умолчанию OFF: отсутствующий ключ = выключено.
 */
/** Гейт ОСНОВНОЙ ветки реактора (идентификация → правила → возврат/отмена/ответ). */
export const RISK_REACTIONS_ENABLED_KEY = 'risk.reactions_enabled';
/** Гейт ветки ДУБЛИКАТОВ. Независим от {@link RISK_REACTIONS_ENABLED_KEY}
 *  осознанно (spec §10): дубликаты не ходят в платёжный сервис и могут быть
 *  включены раньше боевых реакций. */
export const RISK_DUPLICATE_AUTO_RESPONSE_KEY = 'risk.duplicate_auto_response';
/** Shadow-режим: полный прогон решения с журналом, ноль внешних вызовов. */
export const RISK_REACTIONS_SHADOW_KEY = 'risk.reactions_shadow';
/**
 * Тумблер СВИПЕРА дедлайна (`createRiskReactionSweeper`). Отдельный флаг, а не
 * часть {@link RISK_REACTIONS_ENABLED_KEY}: свипер только ЭСКАЛИРУЕТ (маршрутизация
 * внимания оператора) и реклеймит зависшие прогоны — он не трогает ни провайдера,
 * ни деньги, поэтому его включают и выключают независимо от боевых реакций.
 *
 * Env `RISK_REACTION_SWEEP_ENABLED` (воркер) остаётся АВАРИЙНЫМ рубильником
 * процесса: при `false` свипер не создаётся вовсе и этот флаг не читается.
 */
export const RISK_REACTION_SWEEP_ENABLED_KEY = 'risk.reaction_sweep_enabled';
/**
 * ЗАПИСЬ. `.strict()` — опечатка или лишнее поле на записи должны падать, а не
 * тихо оседать в jsonb. Тот же приём, что у `AutoTranslateSetting` в
 * `admin-contracts/src/llm-settings.ts`.
 */
export const RiskAutomationFlagSetting = z.object({ enabled: z.boolean() }).strict();
/**
 * ЧТЕНИЕ. `.passthrough()` — более новый писатель, добавивший поле, не должен
 * при раскатке выглядеть для старого читателя как «флаг сломан» (это молча
 * выключило бы автоматику). Тип `enabled` остаётся строгим: `{enabled:'true'}`
 * не парсится → fail-safe OFF.
 */
export const RiskAutomationFlagStoredSetting = z.object({ enabled: z.boolean() }).passthrough();
//# sourceMappingURL=settings.js.map